// Libraries
import LeftArrow from '../../static/images/left-arrow.png';
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

// Assets

// Styles
import './breadCrumb.scss';

/**
 * BreadCrumb Component
 *
 * @param {Object} data - Data for render
 * @param {String} title - title of component
 * @param {Function} onBackClick - Action on back click
 * @param {Function} onLinkClick - Action on link click
 * @param {Boolean} withBack - true will show back button
 * @param {String} wrapperClass - Wrapper Class
 */

const BreadCrumb = ({
    title,
    breadCrumbs,
    onBackClick,
    withBack,
    wrapperClass = '',
}) => (
    <div className={`back-and-breadcrumbs ${wrapperClass}`}>
        {withBack ? (
            <button className="btn-icon" onClick={onBackClick}>
                <img src={LeftArrow} alt="Back" />
            </button>
        ) : null}
        <div className="breadcrumbs-section">
            <span>{title}</span>
            <ul className="breadcrumbs">
                {breadCrumbs.map(item => (
                    <li>
                        {item.link !== '' ? (
                            <Link to={item.link}>{item.name}</Link>
                        ) : (
                            <Link>{item.name}</Link>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    </div>
);

BreadCrumb.propTypes = {
    actionType: PropTypes.string,
    breadCrumbs: PropTypes.array,
    history: PropTypes.object,
    onBackClick: PropTypes.func,
    title: PropTypes.string,
    withBack: PropTypes.bool,
    wrapperClass: PropTypes.string,
};

export default withRouter(BreadCrumb);
